<div class="container">
    <div class="row">
        <div class="col-lg-10 offset-lg-1 col-md-12 col-sm-12 no-mt-mobile">
            <div class="row big-div-latest mb-3">
                <div class="col-md-12 col-lg-12 pb-2 mb-4">
                    <app-package-and-collection
                        [title]="'Recently Updated'"
                        [packagesQuery]="packagesQuery"
                        [collectionsQuery]="collectionsQuery"
                        [catalogsQuery]="catalogsQuery"
                        (onLoadCatalogsClick)="updateCatalogsFetchingQuery($event)"
                        (onLoadPackagesClick)="updatePackageFetchingQuery($event)"
                        (onLoadCollectionsClick)="updateCollectionFetchingQuery($event)"
                    >
                        <div packagesEmptyState class="empty-state-label pl-3">
                            <p class="text-dark-gray">
                                Either no packages have been published to this registry, or you do not have access to
                                any of the published packages
                            </p>
                            <a href="/docs/publish-data/" class="color-info pt-3">Learn how to publish packages</a>
                        </div>
                        <div packagesErrorState class="empty-state-label pl-3">
                            <p class="text-dark-gray">
                                Could not load the latest packages. Reload the page and if the issue persists please
                                contact support.
                            </p>
                        </div>
                    </app-package-and-collection>
                </div>
            </div>
        </div>
    </div>
</div>
